// TODO: タブレット系（Kindle Fire HDX、Kindle Fire HDX、Nexus、Galaxy Tab...）がレイアウト大崩れするので、修正が必要
// SearchModal.jsx
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
// import debounce from "lodash/debounce";
import Filters from "./Filters";
// import "./css/filters.scss";

// // スクロールイベントを監視して、スタイルを変更
// const modalSf = document.querySelector("#modal_search_filters");
// const modalSfContainer = modalSf.querySelector("#modal_search_filters_container");
// const handleModalSfScroll = debounce(() => {
//  const sfControlsHead = document.querySelector("#search_filters .sf-head");
//  const sfResult = document.querySelector("#search_filters .sf-result");
//  if (!modalSfContainer) return; // もし、modalSfContainerがなければ、処理を中断
//  const isScrolled = modalSfContainer.scrollTop > 0; // 0より大きい場合はtrue
//  if (sfControlsHead) sfControlsHead.classList.toggle("is-scrolled", isScrolled);
//  if (sfResult) sfResult.classList.toggle("is-scrolled", isScrolled);
// }, 0);
// modalSfContainer.addEventListener("scroll", handleModalSfScroll);

function SearchModal() {
 return (
  <>
   <Router>
    <Routes>
     {/* 全ページ共通コンポーネントため、pathを`*` */}
     <Route path="*" element={<Filters />} />
    </Routes>
   </Router>
  </>
 );
}

export default SearchModal;
